import { render } from "./CostReportDetailsItems.vue?vue&type=template&id=5bbefa96&scoped=true"
import script from "./CostReportDetailsItems.vue?vue&type=script&lang=js"
export * from "./CostReportDetailsItems.vue?vue&type=script&lang=js"

import "./CostReportDetailsItems.vue?vue&type=style&index=0&id=5bbefa96&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbefa96"]])

export default __exports__